// Gerador de nomes por nacionalidade.
//
// Cuidado deliberado com ENTROPIA DA SEMENTE: um gerador de nomes alimentado
// por semente pobre produz o mesmo nome em dezenas de clubes. A semente aqui
// mistura clube + temporada + indice + posicao, e o gerador de liga ainda
// deduplica o nome completo. O teste `test-engine.mjs` cobre isso.

import { makeRng } from './rng.js';

const POOLS = {
  BR: {
    first: ['Lucas', 'Gabriel', 'Rafael', 'Matheus', 'Bruno', 'Thiago', 'Felipe', 'Vitor', 'Caio', 'Diego',
      'Andre', 'Marcelo', 'Rodrigo', 'Leandro', 'Fabio', 'Guilherme', 'Eduardo', 'Ricardo', 'Alan', 'Davi',
      'Igor', 'Murilo', 'Otavio', 'Pedro', 'Renan', 'Samuel', 'Tomas', 'Vinicius', 'Wesley', 'Yuri',
      'Arthur', 'Benicio', 'Caua', 'Danilo', 'Elias', 'Fernando', 'Gustavo', 'Heitor', 'Isaac', 'Joao',
      'Kaique', 'Lorenzo', 'Marcos', 'Nathan', 'Osvaldo', 'Paulo', 'Quenio', 'Roberto', 'Sergio', 'Tulio',
      'Ubirajara', 'Valter', 'Washington', 'Ximenes', 'Zeca', 'Alisson', 'Breno', 'Cesar', 'Douglas', 'Emerson',
      'Flavio', 'Geraldo', 'Hugo', 'Italo', 'Jonas', 'Kleber', 'Luan', 'Mauricio', 'Nelson', 'Olavo',
      'Patrick', 'Raul', 'Silvio', 'Tiago', 'Ulisses', 'Victor', 'Wanderley', 'Yago', 'Zilmar', 'Abner'],
    last: ['Silva', 'Santos', 'Oliveira', 'Souza', 'Lima', 'Pereira', 'Costa', 'Almeida', 'Ferreira', 'Rodrigues',
      'Carvalho', 'Gomes', 'Martins', 'Araujo', 'Ribeiro', 'Barbosa', 'Nascimento', 'Cardoso', 'Teixeira', 'Moreira',
      'Correia', 'Dias', 'Fernandes', 'Freitas', 'Machado', 'Monteiro', 'Nunes', 'Pinto', 'Ramos', 'Rocha',
      'Sales', 'Tavares', 'Vieira', 'Xavier', 'Azevedo', 'Bezerra', 'Camargo', 'Duarte', 'Esteves', 'Farias',
      'Guimaraes', 'Henriques', 'Ilha', 'Jardim', 'Klein', 'Leal', 'Maciel', 'Neves', 'Ottoni', 'Prado',
      'Queiroz', 'Reis', 'Sampaio', 'Trindade', 'Uchoa', 'Valente', 'Werneck', 'Zanetti', 'Brandao', 'Coelho',
      'Drummond', 'Espindola', 'Fontes', 'Godoy', 'Horta', 'Iglesias', 'Junqueira', 'Lacerda', 'Mendes', 'Novaes',
      'Pacheco', 'Rezende', 'Siqueira', 'Toledo', 'Ventura', 'Wagner', 'Amaral', 'Bittencourt', 'Cunha', 'Damasceno'],
  },
  US: {
    first: ['James', 'Michael', 'Chris', 'Jalen', 'Tyrese', 'Marcus', 'Devin', 'Jordan', 'Cameron', 'Isaiah',
      'Malik', 'Trey', 'Darius', 'Kyle', 'Brandon', 'Jaylen', 'Terrance', 'Andre', 'Dominic', 'Xavier',
      'Aaron', 'Bryce', 'Caleb', 'Dante', 'Elijah', 'Franklin', 'Grant', 'Harrison', 'Ivan', 'Jamal',
      'Keegan', 'Lamar', 'Miles', 'Nolan', 'Omar', 'Preston', 'Quentin', 'Reggie', 'Shawn', 'Tobias',
      'Ulysses', 'Vance', 'Wendell', 'Zion', 'Anthony', 'Bradley', 'Corey', 'Derrick', 'Everett', 'Fred',
      'Gerald', 'Hunter', 'Ian', 'Josiah', 'Kenneth', 'Lonnie', 'Maxwell', 'Nathaniel', 'Orlando', 'Patrick',
      'Rashad', 'Spencer', 'Trevor', 'Vernon', 'Wesley', 'Zachary', 'Alonzo', 'Baron', 'Clyde', 'Dexter',
      'Emmett', 'Foster', 'Gideon', 'Horace', 'Irving', 'Julius', 'Kirby', 'Landon', 'Mason', 'Nash'],
    last: ['Johnson', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'Wilson', 'Anderson', 'Thomas', 'Taylor',
      'Moore', 'Jackson', 'Martin', 'Thompson', 'White', 'Harris', 'Clark', 'Lewis', 'Walker', 'Hall',
      'Allen', 'Young', 'King', 'Wright', 'Scott', 'Green', 'Baker', 'Adams', 'Nelson', 'Carter',
      'Mitchell', 'Roberts', 'Turner', 'Phillips', 'Campbell', 'Parker', 'Evans', 'Edwards', 'Collins', 'Stewart',
      'Morris', 'Rogers', 'Reed', 'Cook', 'Bell', 'Murphy', 'Bailey', 'Rivera', 'Cooper', 'Richardson',
      'Cox', 'Howard', 'Ward', 'Peterson', 'Gray', 'Ramirez', 'Watson', 'Brooks', 'Sanders', 'Price',
      'Bennett', 'Wood', 'Barnes', 'Ross', 'Henderson', 'Coleman', 'Jenkins', 'Perry', 'Powell', 'Long',
      'Patterson', 'Hughes', 'Flores', 'Washington', 'Butler', 'Simmons', 'Foster', 'Gonzales', 'Bryant', 'Alexander'],
  },
  EU: {
    first: ['Luka', 'Nikola', 'Goran', 'Sergio', 'Pau', 'Ricky', 'Tomas', 'Jonas', 'Dario', 'Vasilije',
      'Bogdan', 'Kristaps', 'Davis', 'Rudy', 'Evan', 'Theo', 'Frank', 'Nando', 'Willy', 'Juancho',
      'Alperen', 'Cedi', 'Furkan', 'Deni', 'Ante', 'Bojan', 'Ivica', 'Mario', 'Zoran', 'Milos',
      'Aleksej', 'Bartosz', 'Cristiano', 'Dimitrios', 'Emir', 'Filip', 'Giannis', 'Hugo', 'Ismael', 'Janis',
      'Kostas', 'Lauri', 'Marko', 'Nemanja', 'Ognjen', 'Petr', 'Radu', 'Stefan', 'Tibor', 'Uros',
      'Vlatko', 'Wojciech', 'Yannick', 'Zeljko', 'Andrei', 'Boris', 'Clement', 'Dejan', 'Elias', 'Fabien',
      'Gyorgy', 'Henri', 'Igor', 'Jakub', 'Karel', 'Lorenzo', 'Matteo', 'Niels', 'Olek', 'Pierre',
      'Rok', 'Simone', 'Tadas', 'Ugo', 'Valdas', 'Wilhelm', 'Xavi', 'Yves', 'Zan', 'Arturs'],
    last: ['Doncic', 'Jokic', 'Dragic', 'Rubio', 'Gasol', 'Satoransky', 'Valanciunas', 'Saric', 'Micic', 'Bogdanovic',
      'Porzingis', 'Bertans', 'Gobert', 'Fournier', 'Maledon', 'Ntilikina', 'Hernangomez', 'Sengun', 'Osman', 'Korkmaz',
      'Avdija', 'Zubac', 'Vucevic', 'Hezonja', 'Teodosic', 'Nedovic', 'Raduljica', 'Simonovic', 'Kalinic', 'Lucic',
      'Sloukas', 'Papagiannis', 'Larkin', 'Vesely', 'Balcerowski', 'Ponitka', 'Sokolowski', 'Waczynski', 'Cel', 'Nowak',
      'Markkanen', 'Salin', 'Koponen', 'Muurinen', 'Sabonis', 'Kuzminskas', 'Motiejunas', 'Grigonis', 'Jokubaitis', 'Brazdeikis',
      'Melli', 'Datome', 'Belinelli', 'Gallinari', 'Fontecchio', 'Polonara', 'Tonut', 'Spissu', 'Mannion', 'Ricci',
      'Voigtmann', 'Schroder', 'Theis', 'Wagner', 'Bonga', 'Hartenstein', 'Kleber', 'Obst', 'Lo', 'Giffey',
      'Heurtel', 'Lessort', 'Yabusele', 'Poirier', 'Albicy', 'Cordinier', 'Jaiteh', 'Okobo', 'Luwawu', 'Diallo'],
  },
};

export const NATIONALITIES = Object.keys(POOLS);

/**
 * Nome completo deterministico.
 * `seedParts` deve conter tudo que distingue o atleta: clube, temporada,
 * indice no elenco e posicao. Semente curta = nomes repetidos em massa.
 */
export function makeName(nationality, ...seedParts) {
  const pool = POOLS[nationality] || POOLS.BR;
  const rng = makeRng(`nome|${nationality}|${seedParts.join('|')}`);
  const first = pool.first[rng.int(pool.first.length)];
  const last = pool.last[rng.int(pool.last.length)];
  return `${first} ${last}`;
}

/**
 * Nome completo garantidamente inedito dentro de `taken` (Set de nomes usados).
 * Varia a semente ate achar um livre; no limite acrescenta inicial do meio,
 * que e o que a vida real faz tambem.
 */
export function makeUniqueName(taken, nationality, ...seedParts) {
  for (let attempt = 0; attempt < 40; attempt++) {
    const name = makeName(nationality, ...seedParts, attempt);
    if (!taken.has(name)) {
      taken.add(name);
      return name;
    }
  }
  const base = makeName(nationality, ...seedParts);
  const [first, ...rest] = base.split(' ');
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < letters.length; i++) {
    const name = `${first} ${letters[i]}. ${rest.join(' ')}`;
    if (!taken.has(name)) {
      taken.add(name);
      return name;
    }
  }
  taken.add(base);
  return base;
}

/** Quantas combinacoes distintas cada pool oferece (usado nos testes). */
export function poolCapacity(nationality) {
  const pool = POOLS[nationality] || POOLS.BR;
  return pool.first.length * pool.last.length;
}
